import React, { useState, useEffect } from 'react'
import Copy from '../../cpn/Copy';
import classes from './loan.module.css';
import { Table } from 'antd';
import LoanCheck from './LoanCheck';
import StateTag from '../../cpn/StateTag';
import ReportCheck from '../report/ReportCheck';
function LoanListNeedRead(props) {
    const [list, setList] = useState([]);
    useEffect(() => {
        if (props.list) {
            const arr = props.list.filter((item) => (item.jk_sp_state === '2' || item.jk_sp_state === '3') && item.jk_sp_jd_name === '抄送');
            // 把未读的放前面
            // 假设"未读"定义为jk_sp_state === '2'
            const unread = arr.filter(item => item.jk_sp_state === '2');
            const read = arr.filter(item => item.jk_sp_state === '3');
            read.sort((a, b) => new Date(b.jk_sp_state_time) - new Date(a.jk_sp_state_time));
            const sortedArr = [...unread, ...read];
            setList(sortedArr);
        }
    }, [props.list]);

    const columns = [
        {
            title: '借款人  ',
            dataIndex: 'jk_kh_name',
            key: 'jk_kh_name',
            width: "20%",
            render: (_, record) =>  <LoanCheck
                                        type='button'
                                        jk_id={record.jk_sp_jk_id} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        jk_bzd_id={record.jk_bzd_id}
                                        jk_price={record.jk_price}
                                        jk_content={record.jk_content}
                                        jk_date={record.jk_date}
                                        jk_date_end={record.jk_date_end}
                                        jk_bzd_name={record.jk_bzd_name}
                                        jk_bzd_danhao={record.jk_bzd_danhao}
                                        jk_type_id={record.jk_type_id}
                                        jk_type_name={record.jk_type_name}
                                        jk_kh_id={record.jk_kh_id}
                                        jk_kh_name={record.jk_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        jk_num={record.jk_num}
                                        jk_amount={record.jk_amount}
                                        jk_state={record.jk_state}
                                        jk_bm_id={record.jk_bm_id}
                                        jk_bm_name={record.jk_bm_name}
                                        jk_khyhzh_id={record.jk_khyhzh_id}
                                        jk_khyhzh_name={record.jk_khyhzh_name}
                                        jk_image_name={record.jk_image_name}
                                        jk_image_file={record.jk_image_file}
                                        jk_ctime={record.jk_ctime}
                                        jk_sp_id={record.jk_sp_id}
                                        jk_sp_yh_id={record.jk_sp_yh_id}
                                        jk_sp_state={record.jk_sp_state}
                                        jk_sp_jk_kh_name={record.jk_sp_jk_kh_name}
                                        jk_sp_jd_name={record.jk_sp_jd_name}
                                    />
        },
        {
            key: 'jk_sp_jk_amount',
            dataIndex: 'jk_sp_jk_amount',
            title: "借款金额",
            width: "6%",            
            render: (text, record) => <span>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
      
        {
            key: 'jk_sp_jk_content',
            dataIndex: 'jk_sp_jk_content',
            title: "备注",
            width: "8%",
            render: (text, record) => <Copy title={text}/>
        },
        {
            key: 'jk_sp_dsbzd_name',
            dataIndex: 'jk_sp_dsbzd_name',
            title: "团队名称",
            width: "8%",
            render: (text, record) => <ReportCheck dsbzd_name={record.jk_sp_dsbzd_name} dsbzd_id={record.jk_sp_dsbzd_id} dsbzd_danhao={record.jk_sp_dsbzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
        },
        {
            key: 'jk_sp_uname',
            dataIndex: 'jk_sp_uname',
            title: "提交记录",
            width: "8%",
            render: (text, record) => <>{record.jk_sp_uname} {record.jk_sp_ctime}</>,
        },
        {
            key: 'jk_sp_state',
            dataIndex: 'jk_sp_state',
            title: "状态",
            width: "5%",            
            render: (text) => <StateTag state={text} /> 
        },
        {
            key: 'jk_sp_jk_id',
            dataIndex: 'jk_sp_jk_id',
            title: "编号",
            width: "5%",       
        }
      
    ]
    return (
        <>
            <Table 
                className={classes.greenHeader}
                size='small'
                bordered
                dataSource={list} 
                columns={columns} 
                rowKey='jk_sp_id'
                locale={{
                    emptyText: '暂无团队报账单' // This will display text when the table is empty
                }}
            />

        </>
    )
}

export default LoanListNeedRead